import { sendRequest } from 'best-modules/vue-utils'
import { DefaultItem } from 'best-modules/plugins/directory/types'
import { TimeStamp } from '@/utils/types/helpers'
import { UserLink } from '@/utils/types/user'

type TemplateRouteSource = 'agreement' | 'default'

type TemplateRouteUser = {
  id: number
  routeId?: number
  documentAgreementRouteId?: number
  userId: number
  user: UserLink<'photo'>
} & TimeStamp

type TemplateRoute = {
  id: number
  name: string
  agreementId: number
  actionId: number
  templateId?: number
  documentAgreementId?: number
  queueNumber: number
  users: TemplateRouteUser[]
  agreement: DefaultItem
  action: DefaultItem
} & TimeStamp

type TemplateRouteSingle = {
  id: number
  name: string
  documentType?: DefaultItem
  type?: DefaultItem
  routes: TemplateRoute[]
}

type TemplateRouteCredentials = {
  name: string
  agreementId?: number | null
  actionId?: number | null
  templateId?: number
  documentAgreementId?: number
  queueNumber?: number
}

type TemplateRouteUserCredentials = {
  userId: number
  routeId?: number
  documentAgreementRouteId?: number
}

const templateRouteList = (
  source: TemplateRouteSource,
  id: number
): Promise<TemplateRoute[] | TemplateRouteSingle> => {
  return sendRequest({
    name: `${source}TemplateRouteList`,
    method: 'get',
    url:
      source === 'agreement'
        ? `/json/document/agreement/${id}/routes`
        : `/json/documentTemplate/${id}`,
  })
}

const templateRouteCreate = (
  source: TemplateRouteSource,
  credentials: TemplateRouteCredentials
): Promise<TemplateRoute> => {
  return sendRequest({
    name: `${source}TemplateRouteCreate`,
    method: 'post',
    url:
      source === 'agreement'
        ? '/json/document/agreement/route'
        : '/json/documentTemplate/route',
    payload: credentials,
  })
}

const templateRouteUpdate = (
  source: TemplateRouteSource,
  id: number,
  credentials: TemplateRouteCredentials
): Promise<TemplateRoute> => {
  return sendRequest({
    name: `${source}TemplateRouteUpdate`,
    method: 'put',
    url:
      source === 'agreement'
        ? `/json/document/agreement/route/${id}`
        : `/json/documentTemplate/route/${id}`,
    payload: credentials,
  })
}

const templateRouteDelete = (
  source: TemplateRouteSource,
  id: number
): Promise<void> => {
  return sendRequest({
    name: `${source}TemplateRouteDelete`,
    method: 'delete',
    url:
      source === 'agreement'
        ? `/json/document/agreement/route/${id}`
        : `/json/documentTemplate/route/${id}`,
  })
}

const templateRouteUserCreate = (
  source: TemplateRouteSource,
  credentials: TemplateRouteUserCredentials
): Promise<TemplateRouteUser> => {
  return sendRequest({
    name: `${source}TemplateRouteUserCreate`,
    method: 'post',
    url:
      source === 'agreement'
        ? '/json/document/agreement/route/user'
        : '/json/documentTemplate/route/user',
    payload: credentials,
  })
}

const templateRouteUserDelete = (
  source: TemplateRouteSource,
  id: number
): Promise<void> => {
  return sendRequest({
    name: `${source}TemplateRouteUserDelete`,
    method: 'delete',
    url:
      source === 'agreement'
        ? `/json/document/agreement/route/user/${id}`
        : `/json/documentTemplate/route/user/${id}`,
  })
}

export {
  TemplateRouteSource,
  TemplateRoute,
  TemplateRouteSingle,
  TemplateRouteUser,
  TemplateRouteCredentials,
  templateRouteList,
  templateRouteCreate,
  templateRouteUpdate,
  templateRouteDelete,
  templateRouteUserCreate,
  templateRouteUserDelete,
}
